var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInboxA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 846 621.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-3,.cls-4,.cls-5,.cls-6{stroke:#ea5599;}.cls-2{stroke:#0e090c;}.cls-3{stroke-dasharray:0 0 5.04 5.04;}.cls-7{fill:#f9f8f4;}.cls-8{fill:#ebeaf4;}.cls-9{fill:#fff7d3;}.cls-10{fill:#a49dc1;}.cls-11{fill:#dbd8e6;}.cls-12{fill:#d9d6e5;}.cls-13{fill:#0e090c;}.cls-4{stroke-dasharray:0 0 5.01 5.01;}.cls-5{stroke-dasharray:0 0 5.05 5.05;}.cls-6{stroke-dasharray:0 0 5.02 5.02;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vektor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M812.16,178.68s-2.55-18.13-7.63-31.32l-13.36,18.16,21,13.17h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M577.98,398.98c-17.49-5.96-27.05-28.19-45.06-36.75-32.88-15.63-68.7,11.8-59.2,48.23,9.59,36.76,52.19,45.79,48.39,76.89-1.45,11.85-1.86,23.47,.58,34.82h80.03l-24.74-123.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M227.16,205.36c24.19-20.63,60.68-5.58,60.95,27.32,.27,33.19-28.6,39.88-18.32,65.28,3.92,9.67,8.93,33.11-3.12,52.43l-39.51-25.66v-119.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M584.96,287.49c-15.87,3.36-28.79,16.09-32.47,37.37-6.47,37.44,36.09,59.22,23.16,87.78-16.26,35.86-17.81,74.95,27.08,109.53l76.25,.79v-195.74s-9.44,2.19-26.38-2.95c0,0,.51,11.51-3.09,16.88-3.58,5.35-13.02,8.18-25.47,6.65l2.5-6.16s-3.54,1.9-7.5,.6l12.5-24.35s-20.56-8.29-35.37-20.9l-11.2-9.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M294.21,427.14s2.19,55.02-41.88,95.82h-25.37v-105.37c24.26,7.27,53.48,9.14,53.48,9.14l13.77,.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M290.62,395.43s-4.33-18.16-12.48-32.51c-7.56-13.32-25.09-35.5-51.18-49.83v82.92s35.95,7.62,63.67-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M631.53,317.89c-18.77-6.49-46.06-23.57-64.2-54.16,0,0,65.92-3.29,86.77-65.31,0,0,8.42,16.57,16.23,25.24v93.71l-36.78-3.65-2.02,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M656.98,119.46v-10.15c-29.75,3.09-35.09-32.32-35.09-32.32,0,0-64.92,26.25-73.4,107.65h70.55l37.94-65.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M461.17,184.65l25.85,16.57-13.61,22.95s14.33,5.41,17.48-15.23l5.43-1.76,12.68,8.12-48.26,74.76-41.17-26.38s7.67-3.2,5.68-16.54c0,0,27.88,.82,25.4-17.06l-22.85,6.27,33.39-51.7h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M526.23,192.77s-4.06,13.72-4.06,34.3,6.78,38.61,15.68,38.61,15.68-17.01,15.68-40.52-5.18-30.07-5.18-30.07l-22.13-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M399.85,319.25s6.28,11.19,15.94,21.71c9.66,10.53,26.67,21.8,32.96,14.39,6.29-7.42-4.03-29.16-16.81-43.54-12.78-14.39-26.43-21.05-26.43-21.05l-5.64,28.5h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M226.95,313.07c-5.13-2.96-10.8-5.78-16.93-8.26,10.35,27.8,9.24,48.46,.9,58.34-8.72,10.33-22.31,4.6-22.31,4.6,.62,9.57-1.54,16.53-2.26,18.55l40.59,9.7v-82.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165.27,346.01c-19.56,1.72-25.59-20.14-25.59-20.14l-5.37-29.37c-20.62,3.85-41.83,13.24-61.93,30.72-54.94,47.81-43.53,114.45-43.53,114.45l91.07-71.24,49.28,11.78c2.86-18.73-3.94-36.19-3.94-36.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M670.34,133.26c-4.12-1.38-8.25-3.32-11.23-8.76-9.14-16.68,2.82-34.37,6.64-57.76,3.82-23.39-.41-43.76-.41-43.76,0,0-1.1,15.01-5.87,18.56-4.77,3.56-11.26,2.16-18.49-.48-8.51-3.11-18.27-6.31-30.49-2.15,0,0,14.43-38.91,51.76-38.91,14.66,0,24.57,5.99,33.77,16.06,9.99,10.95,17.28,16.47,29.68,18.34,12.4,1.87,27.8,11.61,32.31,26.39,4.51,14.78,11.65,20.41,28.55,28.89,16.91,8.49,22.54,24.83,22.54,40.56s-7.96,41.95-41.71,40.05c-31.72-1.78-44.72-25.86-41.71-45.88l-55.35-34.73v43.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M166.09,345.13c-2.84-5.1-5.32-9.28-5.32-9.28,0,0-2.31,6.92-10.27,1.88-7.96-5.05-12.3-17.16-6.8-20.91,5.5-3.75,13.6,7.03,13.6,7.03-4.06-17.81-16.07-27.66-16.07-27.66,0,0,10.96,.97,16.42-2.14,13.12-7.48,7.6-17.09,26.32-17.51,18.72-.42,23.4-19.39,12.09-31.24-11.31-11.85-24.57-5.04-28.91,0-4.36,5.05-8.9,8.35-15.33,10.3-6.43,1.94-19.29,1.56-24.18,9.91-4.88,8.35-3.31,17.09,.58,23.12,3.89,6.01,3.71,11.45,.39,15.92-3.31,4.47-7.4,9.51-7.6,14.95-.2,5.44,2.92,9.13,9.51,10.3,6.59,1.17,8.22,5.64,9.39,7.93,1.17,2.29,2.74,12.27,12.85,14.02,4.36,.76,11.16-1.21,12.68-6.35l.63-.27h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M678.98,327.22s37.22,1.21,68.35-17.93l-17.45-18.54h-50.92v36.47h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M256.44,178.62c23.52,0,42.6-19,42.6-42.44s-19.07-42.44-42.6-42.44-42.6,19-42.6,42.44,19.07,42.44,42.6,42.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M620.12,41.15s-3.77,17.16,2.77,39.56c6.35,21.77,19.55,29.95,30.38,28.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M636.15,60.8l-1.71,16.2h5.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M653.68,56.72s-3.65,6.07-8.28,.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M630.97,58.28s-3.3,5.86-7.11-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M678.98,492.52l-88.18-168.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M648.77,365.91l-18.9,32.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M656.71,449.92l-62.34,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M565.23,454.98l-53.84-59.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M548.99,438.69l-26.83-.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M528.13,413.72l1.47-23.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.16,278.85l25.66-50.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.6,269l22.43-6.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.93,247.75l-6.52-19.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M581.18,501.01l-30.07,3.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M791.17,165.51l20.99,13.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M626.55,341.64c-3.71,2.01-7.5,.6-7.5,.6l14.51-28.28,36.79,3.42V89.69l55.35,34.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M637.61,314.34l-13.57,33.45s13.39,2.36,22.3-3.47c4.5-2.95,6.25-8.42,6.25-19.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M643.06,314.84l-10.48,33.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M648.77,315.37l-6.74,31.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.36,522.96H226.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M602.73,522.17s-22.06-14.03-33.26-42.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M678.98,290.75v62.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M670.34,290.75h92.33l-76.49-177.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M656.98,119.46l-37.94,65.18h-137.48l-4.16,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M537.85,184.64c8.66,0,15.68,18.14,15.68,40.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M393.14,287.49c-3.47,10.85,2.88,29.62,16.98,47.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M548.36,195.08l-43.58-4.55s2.58,15.23-13.89,18.4c0,0-2.38,19.98-17.48,15.23l18.07-30.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M729.88,290.75c5.73,6.11,10.83,11.54,17.45,18.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M652.61,136.18s-8.58,21.78-3.06,46.66c2.81,12.68,6.61,22.49,20.79,40.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M537.85,265.68c44.72,0,94.18-11.06,114.75-63.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M652.61,324.27c9.01,1.93,18.38,2.95,27.97,2.95,73.24,0,132.62-59.16,132.62-132.14,0-5.55-.34-11.03-1.02-16.4-.85-6.76-2.2-13.36-4.02-19.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.21,438.25c-.44,1.1-.86,2.18-1.27,3.27"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M485.68,448.12c-.25,.79-.49,1.59-.73,2.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M483.62,455.35c-2.37,9.31-3.81,19.02-4.5,29.65-4.84,74.72,43.03,132.09,127.45,135.57,75.08,3.11,144.77-54.08,136.04-143.84-5.71-65.55-3.12-96.81,26.76-125.41,22.22-21.27,49.07-23.15,64.21-22.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M836.08,329.42c.88,.08,1.71,.18,2.48,.27"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M842.04,330.22c2.21,.38,3.45,.69,3.45,.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.69,404.24c.27,28.29-9.1,63.2-42.91,81.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.6,227.65h-16.77s-.44,2.21-21.23,67.87c-20.79,65.66-84.47,118.99-165.42,100.48-80.93-18.51-105.26-25.56-105.26-25.56L.5,463.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M448.75,355.34s-74.51,102.77-221.79,62.23v105.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.71,396.93l-52.29,111.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M506.91,334.33c13.88,0,25.13-11.21,25.13-25.04s-11.25-25.04-25.13-25.04-25.13,11.21-25.13,25.04,11.25,25.04,25.13,25.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M334.03,274.56c9.93,0,17.98-8.02,17.98-17.92s-8.05-17.92-17.98-17.92-17.98,8.02-17.98,17.92,8.05,17.92,17.98,17.92Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.79,393.61s-.79-.39-2.17-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.44,389.62c-13.02-9.29-41.52-35.78-41.52-89.6,0-47.39,28.22-81.17,70.79-98.02,49.7-19.69,92.06-6.94,122.81-29.89,30.75-22.95,29.86-62.26,19.31-81.65-10.41-19.14-34.5-37.17-65.84-29.65-26.54,6.37-43.22,25.91-47.45,47.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.11,110.75c-.12,.82-.23,1.65-.32,2.48"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.95,311.85v-109.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M415.28,239.78l35.36-9.7s4.96,16.26-25.4,17.06c0,0,4.18,18.82-14.78,18.54l-10.61,53.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.77,378.9l7.4,23.76,17.84-17.65,5.84,22.67,20.35-16.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.02,385.01s-.45,11.19-6.94,20.38c-6.49,9.19-8.8,18.06-6.08,32.42,2.72,14.36,2.1,28.4-9.01,40.29-11.11,11.89-14.47,23.53-11.95,44.87,2.51,21.33-1.68,33.29-14.26,46.22-12.58,12.93-14.26,26.51-14.05,34.02"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.05,153.98s.91-.09,2.47-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M564.44,152.49c13.24-3.62,39.76-15.54,41.03-53.1,1.52-45.6-39.41-58.24-53.3-58.24-35.75,0-60.42,25.06-62.68,56.42-2.26,31.37,20.27,44.25,38.28,27.99,18.01-16.25,11.64-52.07,7.14-68.85-4.13-15.39-16.15-40.43-44.46-53.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M488.14,2.22c-.76-.32-1.53-.64-2.32-.94"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.98,329.01l6.94-3.25-11.81-19.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.11,306.18s2.24-7.93,10.52-4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.93,309.3s-8.5-6.58-13.44,6.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.11,386.92s3.57-8.9,2.17-19.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.1,382.87s3.74-18.16-4.74-39.43c5.33,9.88,16.54,25.89,33.16,25.89,24.02,0,28.36-38.48,0-92.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M424.9,256.69l46.71-12.75-9.25-52.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.34,522.96s-9.89,9.95-25.37,18.48c-18.96,10.44-41.9,17.36-65.88,17.36-64.27,0-117.91-45.39-130.4-105.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.08,423.62c1.74,0,3.16-1.41,3.16-3.15s-1.41-3.15-3.16-3.15-3.16,1.41-3.16,3.15,1.41,3.15,3.16,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.77,502.46c1.74,0,3.16-1.41,3.16-3.15s-1.41-3.15-3.16-3.15-3.16,1.41-3.16,3.15,1.41,3.15,3.16,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.36,592.06c1.74,0,3.16-1.41,3.16-3.15s-1.41-3.15-3.16-3.15-3.16,1.41-3.16,3.15,1.41,3.15,3.16,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.63,341.74s-12.6,2.32-17.28-1.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M181.06,312.49c1.33,0,2.41-1.08,2.41-2.4s-1.08-2.4-2.41-2.4-2.41,1.08-2.41,2.4,1.08,2.4,2.41,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M200.76,305.95c1.33,0,2.41-1.08,2.41-2.4s-1.08-2.4-2.41-2.4-2.41,1.08-2.41,2.4,1.08,2.4,2.41,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M637.28,87.15s9.14,.65,12.27-1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M589.5,522.17h45.39"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.32,296.99s.43,.78,1.11,2.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M496.45,303.84c5.14,12.72,13.8,41.66,3.35,74-5.92,18.33-31.24,72.08-113.4,60.84-28.65-3.92-54.15-21.66-65.69-45.94-15.63-32.9-3.37-62.24,20.93-63.75,7.11-.44,14.04,1.38,20.45,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.28,335.17c.7,.44,1.4,.89,2.09,1.37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxA);
export default __webpack_public_path__ + "static/media/Inbox_A.88c111f4dd1df48fde2a845b08323709.svg";
export { ForwardRef as ReactComponent };